import React from "react";
import {encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { Helpers } from "../../config/Helpers";

class OrderActive extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessBranchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : '',
            search: '',
            loading: true,
            orderData: [],
            modalOpen: '',
            selectedIdStatus: 'all',
            selectedIdProduk: 'all',
            selectedIdDate: 'all',
            selectedStartDate: '',
            selectedEndDate: '',
            dataStatusTransaksi: [
                { name: 'Semua Transaksi', status: 'parent', value: 'all' },
                { name: 'Semua Transaksi Berlangsung', status: 'parent', value: 'all_aktif' },
                { name: 'Diproses', status: 'child', value: 'proses' },
                { name: 'Pengiriman/Pengambilan', status: 'child', value: 'waiting_pick' },
                { name: 'Menunggu Pembayaran', status: 'child', value: 'waiting_pay' },
                { name: 'Produk Dalam Pemesanan', status: 'child', value: 'waiting_product' },
                { name: 'Selesai', status: 'parent', value: 'done' },
                { name: 'Tidak Berhasil', status: 'parent', value: 'failed' },
            ],
            dataFilterProduct: [
                { name: 'Semua Produk', deskripsi: null, value: 'all' },
                { name: 'Belanja', deskripsi: 'Makanan, Minuman, Keperluan Dapur, dan lainnya', value: 'belanja' },
                { name: 'Top-up & Tagihan', deskripsi: 'Pulsa, Tagihan Listrik, Donasi, dan lainnya', value: 'ppob' },
            ],
            dataFilterDate: [
                { name: 'Semua Tanggal', custom: false, value: 'all' },
                { name: '30 Hari Terakhir', custom: false, value: '30' },
                { name: '90 Hari Terakhir', custom: false, value: '90' },
                { name: 'Pilih Tanggal Sendiri', custom: true, value: 'custom' },
            ],
        };
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getOrders();
        }
    }

    getLabel = (list, value) => {
        const found = list.filter((item) => item.value === value);
        return (found.length > 0) ? found[0].name : '';
    };

    getOrders = () => {
        this.setState({ loading: true });

        const custom = (this.state.selectedIdDate === 'custom') ? (this.state.selectedStartDate + ' - ' + this.state.selectedEndDate) : '';

        Helpers.getListOrderCustom(
            'no',
            this.state.sessUserCode,
            this.state.selectedIdStatus,
            this.state.selectedIdProduk,
            this.state.selectedIdDate,
            custom,
            this.state.search
        ).then(res => {
            this.setState({
                orderData: (res) ? res : [],
                loading: false
            });
        });
    };

    handleSearch = (e) => {
        e.preventDefault();
        this.getOrders();
    };

    openModal = (modal) => {
        this.setState({ modalOpen: modal });
    };

    closeModal = () => {
        this.setState({ modalOpen: '' });
    };

    selectStatus = (value) => {
        this.setState({ selectedIdStatus: value, modalOpen: '' }, () => {
            this.getOrders();
        });
    };

    selectProduk = (value) => {
        this.setState({ selectedIdProduk: value, modalOpen: '' }, () => {
            this.getOrders();
        });
    };

    selectDate = (value) => {
        if(value === 'custom'){
            this.setState({ selectedIdDate: value });
        }else{
            this.setState({ selectedIdDate: value, modalOpen: '' }, () => {
                this.getOrders();
            });
        }
    };

    applyCustomDate = () => {
        if(!this.state.selectedStartDate || !this.state.selectedEndDate){
            toast.error('Silahkan pilih tanggal mulai dan akhir');
            return;
        }

        this.setState({ modalOpen: '' }, () => {
            this.getOrders();
        });
    };

    goDetail = (object) => {
        if(object.TipeTransaksi === 'ppob'){
            window.location.href = './ppob-details?trxid=' + base64_encode(object.KodeTransaksiOrder);
        }else{
            window.location.href = './account-orders-details?trxid=' + base64_encode(object.KodeTransaksiOrder);
        }
    };

    handleReorder = (e, kode) => {
        e.stopPropagation();

        if (window.confirm('Apakah anda yakin akan memesan ulang barang-barang di pesanan ini?')) {
            Helpers.CreateReorder(kode, this.state.sessUserCode, this.state.sessBranchCode).then(res => {
                if(res.length > 0){
                    const obj = res[0];

                    if(obj.alert === 'success'){
                        setTimeout(() => {
                            window.location.href = './cart';
                        }, 800);
                    }

                    toast[obj.alert](obj.message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            });
        }
    };

    render() {
        const statusBadge = (status) => {
            if(status === 'finish' || status === 'Finished' || status === 'done'){
                return { bg: '#D4FFE0', color: '#1DA750' };
            }
            if(status === 'canceled' || status === 'expired' || status === 'failed'){
                return { bg: '#FEEBEF', color: '#F0142F' };
            }
            return { bg: '#FFF1E6', color: '#F47626' };
        };

        return (
            <>
                <main className="main pages order-page-wrap">
                    <div className="order-hero">
                        <div className="order-hero-top">
                            <a href="./" className="order-hero-back"><i className="fi-rs-arrow-small-left"></i></a>
                            <h1 className="order-hero-title">Transaksi Saya</h1>
                        </div>

                        <div className="order-filter-row">
                            <div className="order-filter-chip" onClick={() => {this.openModal('status')}}>
                                {this.getLabel(this.state.dataStatusTransaksi, this.state.selectedIdStatus)}
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                            <div className="order-filter-chip" onClick={() => {this.openModal('produk')}}>
                                {this.getLabel(this.state.dataFilterProduct, this.state.selectedIdProduk)}
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                            <div className="order-filter-chip" onClick={() => {this.openModal('date')}}>
                                {(this.state.selectedIdDate === 'custom' && this.state.selectedStartDate) ? (this.state.selectedStartDate + ' s/d ' + this.state.selectedEndDate) : this.getLabel(this.state.dataFilterDate, this.state.selectedIdDate)}
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                        </div>
                    </div>

                    <div className="order-search-wrap">
                        <form method="post" onSubmit={(e) => {this.handleSearch(e)}}>
                            <i className="fi-rs-search order-search-icon"></i>
                            <input type="text" placeholder="Cari transaksi ..." value={this.state.search} onChange={e => this.setState({search: e.target.value})}/>
                        </form>
                    </div>

                    <div className="order-list-wrap">
                        {
                            this.state.loading ? (
                                [1,2,3].map((i) => (
                                    <div className="order-card" key={i}>
                                        <Skeleton height={18} width={'50%'} />
                                        <Skeleton height={60} style={{marginTop: '10px'}} />
                                    </div>
                                ))
                            ) : this.state.orderData.length > 0 ? (
                                this.state.orderData.map((object, i) => {
                                    const badge = statusBadge(object.new_status);
                                    return (
                                        <div className="order-card" key={i} onClick={() => {this.goDetail(object)}}>
                                            <div className="order-card-top">
                                                <div>
                                                    <div className="order-card-code">{object.KodeTransaksiOrder}</div>
                                                    <div className="order-card-date">{object.dates}</div>
                                                </div>
                                                <span className="order-card-badge" style={{backgroundColor: badge.bg, color: badge.color}}>
                                                    {object.new_status_name}
                                                </span>
                                            </div>

                                            {
                                                object.cust_owner && (
                                                    <div className="order-card-owner">{(object.cust_owner || '').toString().toUpperCase()}</div>
                                                )
                                            }

                                            <div className="order-card-divider"></div>

                                            <div className="order-card-body">
                                                <div className="order-card-thumb">
                                                    <img src={object.DisplayOrder} alt=""/>
                                                </div>
                                                <div className="order-card-info">
                                                    <div className="order-card-name">{object.DisplayOrderName}</div>
                                                    {
                                                        object.TotalItem > 1 && (
                                                            <div className="order-card-more">+{object.TotalItem - 1} Barang Lainnya</div>
                                                        )
                                                    }
                                                    {
                                                        object.PreOrder === 'yes' && (
                                                            <div className="order-card-preorder">Pre Order</div>
                                                        )
                                                    }
                                                </div>
                                            </div>

                                            {
                                                (object.CatatanOrder && object.CatatanOrder !== '-' && object.CatatanOrder !== 'null') && (
                                                    <div className="order-card-note">
                                                        <i className="fi-rs-notebook"></i>
                                                        <span>{object.CatatanOrder}</span>
                                                    </div>
                                                )
                                            }

                                            <div className="order-card-footer">
                                                <div>
                                                    <div className="order-card-total-label">Total Belanja</div>
                                                    <div className="order-card-total-value">Rp {object.GrandTotal}</div>
                                                </div>
                                                {
                                                    (object.new_status === 'finish' || object.new_status === 'Finished' || object.new_status === 'done') && (
                                                        <button type="button" className="order-btn-reorder" onClick={(e) => {this.handleReorder(e, object.KodeTransaksiOrder)}}>
                                                            Beli Lagi
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="order-empty">
                                    <i className="fi-rs-receipt"></i>
                                    <p>Belum ada transaksi ditemukan</p>
                                </div>
                            )
                        }
                    </div>
                </main>

                {/* Modal Filter Status */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'status' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Mau lihat status apa?</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataStatusTransaksi.map((item, i) => {
                                    const active = this.state.selectedIdStatus === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat' + (active ? ' active' : '') + (item.status === 'child' ? ' modal-picker-item-child' : '')}
                                            onClick={() => {this.selectStatus(item.value)}}
                                        >
                                            <span className="modal-picker-item-text">{item.name}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                {/* Modal Filter Produk */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'produk' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Mau lihat produk apa?</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataFilterProduct.map((item, i) => {
                                    const active = this.state.selectedIdProduk === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat' + (active ? ' active' : '')}
                                            onClick={() => {this.selectProduk(item.value)}}
                                        >
                                            <span className="modal-picker-item-text">
                                                <span className="modal-picker-item-title">{item.name}</span>
                                                {
                                                    item.deskripsi && (
                                                        <span className="modal-picker-item-subtitle">{item.deskripsi}</span>
                                                    )
                                                }
                                            </span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                {/* Modal Filter Tanggal */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'date' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Pilih Tanggal</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataFilterDate.map((item, i) => {
                                    const active = this.state.selectedIdDate === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat' + (active ? ' active' : '')}
                                            onClick={() => {this.selectDate(item.value)}}
                                        >
                                            <span className="modal-picker-item-text">{item.name}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>

                        {
                            this.state.selectedIdDate === 'custom' && (
                                <div className="order-custom-date">
                                    <div className="order-custom-date-row">
                                        <input type="date" value={this.state.selectedStartDate} onChange={e => this.setState({selectedStartDate: e.target.value})}/>
                                        <span>s/d</span>
                                        <input type="date" value={this.state.selectedEndDate} onChange={e => this.setState({selectedEndDate: e.target.value})}/>
                                    </div>
                                    <button type="button" className="auth-btn-primary" onClick={() => {this.applyCustomDate()}}>Terapkan</button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default OrderActive;
